module.exports = __webpack_public_path__ + "static/media/red-tag-sale-background.90ab8ea8.webp";